/**
 * @component agrupa as configurações gerais do sistema
 *
 * @classname Constants
 * @author GustavoLiu
 * @since 07/10/2022
 */
export abstract class Constants {
    static readonly ATTENDANCE_FORM_FIX_POINT = "1 - Ponto Fixo";
    static readonly ATTENDANCE_FORM_HOME_SERVICE = "2 - Domicílio";
    static readonly LINK_SUHAI = "agendasuhai";
    static readonly MSG_ERRO_SUHAI = "Prezado cliente, por favor entre em contato com o nosso SAC (11) 3003 - 0335 (Opção 7 para agendamento da instalação do seu rastreador)";
    static readonly TIPO_VEICULO_LIBERA_DOMICILIO = ["CAMINHAO", "CARRETA"];
    static readonly CLIENTE_LIBERA_DOMICILIO_SUHAI = "SUHAI";
    static readonly CLIENTE_LIBERA_DOMICILIO_SURA = "SURA";
    static readonly CLIENTE_LIBERA_DOMICILIO_LIBERTY = "LIBERTY";
    static readonly SECRET_KEY = "NxTr@cK3r2847";
    static readonly ESCOLHA_CEP_OU_DOMICILIO = "Para sua região o atendimento é em domicilio. Altere o CEP para outro local, ou escolha domicilio."
    static readonly YELUM_COSTUMER = "YELUM SEGUROS S.A";
    static readonly MERCEDES_BENZ_VEHICLE = 'MERCEDES-BENZ';
    static readonly ERROR_CONTACT_SUPORT = 'Erro ao tentar agendar, tente novamente mais tarde, se o problema persistir contate o suporte!'
    static readonly ID_GROUP_CORPORATIVE = 9;
    static readonly POINT_FIX = "1 - Ponto Fixo"
    static readonly REMOTE_POINT = "2 - Domicílio"

    static readonly EMPTY_NUMBER = "Preencha o número do endereço!"
}
